import { UrlPathPrefix, buildMyEvLegacyLink } from 'projects/sharedComponents/src/services/links/linkBuilder';

import { LinkProps } from '@mui/material';
import { PersonalizedVariableContentFragment } from 'projects/sharedComponents/src/generated/graphql-client-types';
import { replaceTextPersonalizedVariableContent } from 'projects/sharedComponents/src/pet/careResources/contentful/replacePersonalizedVariableContent';

function isLegacyMyEvLink(url: string): url is UrlPathPrefix {
  return url.startsWith('/');
}

function isMyEvLink(url: string): boolean {
  return url.includes('my.embarkvet.com');
}

export function getTabPropsForContentfulLink(url: string): Pick<LinkProps, 'rel' | 'target'> | null {
  const isInternalLink = isLegacyMyEvLink(url) || isMyEvLink(url);
  return !isInternalLink
    ? {
        rel: 'noopener',
        target: '_blank',
      }
    : null;
}

export function getContentfulHref(pet: PersonalizedVariableContentFragment, url: string): string {
  const personalizedUrl = replaceTextPersonalizedVariableContent(pet, url);

  if (isLegacyMyEvLink(personalizedUrl)) {
    return buildMyEvLegacyLink(personalizedUrl);
  }

  return personalizedUrl;
}
